import { colors } from '@/lib/tokens'

const SUMMA_PLUS_PATH = 'M74.332 24.494v12.609c0 2.153-1.716 3.9-3.833 3.9s-3.833-1.747-3.833-3.9v-12.61h-11.89c-2.097 0-3.798-1.715-3.798-3.832s1.7-3.833 3.798-3.833h11.89V4.902c0-2.154 1.716-3.9 3.833-3.9s3.833 1.746 3.833 3.9v11.926H87.18c2.097 0 3.797 1.716 3.797 3.833s-1.7 3.833-3.797 3.833H74.33z'
const SUMMA_SQUARE_PATH = 'M83.63 41.312V79.858A3.69 3.69 0 0 1 79.94 83.549H12.015A3.685 3.685 0 0 1 8.326 79.86V11.932A3.681 3.681 0 0 1 12.007 8.242H50.897V0.897H12.007C5.916 0.896 0.978 5.831 0.978 11.932V79.86C0.978 85.955 5.913 90.896 12.014 90.896H79.943C86.037 90.896 90.978 85.954 90.978 79.858V41.312Z'
const SUMMA_ICON_PATH = SUMMA_PLUS_PATH + SUMMA_SQUARE_PATH
const SUMMA_SQUARE_OUTLINE = 'M90.978 41.312 V79.858 C90.978 85.954 86.037 90.896 79.943 90.896 H12.014 C5.913 90.896 0.978 85.955 0.978 79.86 V11.932 C0.978 5.831 5.916 0.896 12.007 0.897 H50.897'

export function SummaLoader({ size = 48 }: { size?: number }) {
  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
        style={{ position: 'absolute', width: size, height: size, overflow: 'hidden' }}>
        <g fill={colors.border} opacity={0.2}>
          <path d={SUMMA_ICON_PATH} fillRule="evenodd"/>
        </g>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
        style={{ position: 'absolute', width: size, height: size, overflow: 'hidden' }}>
        <path d={SUMMA_SQUARE_OUTLINE}
          fill="none" stroke={colors.primary} strokeWidth="7" strokeLinecap="round"
          className="summa-trace-sq" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
        style={{ position: 'absolute', width: size, height: size }}>
        <g fill={colors.primary} className="summa-flash-plus">
          <path d={SUMMA_PLUS_PATH} fillRule="evenodd"/>
        </g>
      </svg>
      <style>{`
        .summa-trace-sq {
          stroke-dasharray: 270;
          stroke-dashoffset: 270;
          animation: trace-sq 2.4s ease-in-out infinite;
        }
        .summa-flash-plus {
          opacity: 0;
          animation: flash-plus 2.4s ease-in-out infinite;
        }
        @keyframes trace-sq {
          0%   { stroke-dashoffset: 270; opacity: 0; }
          3%   { opacity: 1; }
          75%  { stroke-dashoffset: 0; opacity: 1; }
          80%  { opacity: 0; }
          100% { stroke-dashoffset: 0; opacity: 0; }
        }
        @keyframes flash-plus {
          0%   { opacity: 0; }
          78%  { opacity: 0; }
          80%  { opacity: 1; }
          88%  { opacity: 1; }
          92%  { opacity: 0; }
          100% { opacity: 0; }
        }
      `}</style>
    </div>
  )
}
